module.exports = __webpack_public_path__ + "img/85.4c0d17e8.jpg";